import { apiClient } from './apiClient';

export interface DemoCredential {
  account: string;
  role: string;
  password: string;
}

export interface DemoSeedResult {
  alreadySeeded: boolean;
  companyName?: string;
  guardCount?: number;
  siteCount?: number;
  reportCount?: number;
  credentials?: DemoCredential[];
  message?: string;
}

export interface DemoStatusResult {
  isSeeded: boolean;
  guardCount: number;
  siteCount: number;
  reportCount: number;
  clientCount: number;
}

class DemoService {
  async seedDemoData(): Promise<DemoSeedResult> {
    const response = await apiClient.post<DemoSeedResult>('/demo/seed');
    if (response.success && response.data) {
      return response.data;
    }
    const errorDetail = response.error ? `: ${response.error}` : '';
    throw new Error((response.message || 'Failed to seed demo data') + errorDetail);
  }

  async cleanupDemoData(): Promise<void> {
    const response = await apiClient.delete<void>('/demo/cleanup');
    if (!response.success) {
      const errorDetail = response.error ? `: ${response.error}` : '';
      throw new Error((response.message || 'Failed to clean up demo data') + errorDetail);
    }
  }

  async getDemoStatus(): Promise<DemoStatusResult> {
    const response = await apiClient.get<DemoStatusResult>('/demo/status');
    if (response.success && response.data) {
      return response.data;
    }
    const errorDetail = response.error ? `: ${response.error}` : '';
    throw new Error((response.message || 'Failed to get demo status') + errorDetail);
  }
}

export const demoService = new DemoService();
export default demoService;
